import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import URC from 'ui-react-common';
import formInputs from '../../../../components/form-inputs';
import { actionCreator, stateSelectors } from '../../redux';

const UserService = URC.services.UserService;
const { Form } = URC.ui.components.forms;
const { Stack } = URC.ui.components;
const { Item } = Stack;
const { SocialSecurity, Birthdate } = URC.ui.components.forms.configured;
const { Address, FirstName, LastName, ContinueButton } = formInputs;
const { Disclosures, disclosureTypes } = formInputs.disclosures;

export class PIIRetryForm extends Component {
    constructor(params) {
        super(params);
        this.state = {
            clientResidentState: ''
        };
    }

    parseForm(formValues) {
        let parsedForm = formValues;
        const { socialSecurity, disclosures } = formValues;
        parsedForm.birthdate = Birthdate.parseBirthday(formValues);
        parsedForm = Birthdate.clearForm(parsedForm);
        parsedForm.socialSecurity = socialSecurity.replace(/-/g, '');
        if (disclosures) parsedForm.disclosures = (disclosures[0] === 'disclosures');
        return parsedForm;
    }

    handleFormChange(elementKey, elementData, formState) {
        const { state: residentState } = formState.getValues();
        if (residentState) {
            this.setState({
                clientResidentState: residentState
            });
        }
    }

    render() {
        const { fetchingPIIRetry, firstName, lastName, piiRetry } = this.props;

        return (
            <Form
                id="applicationForm"
                name="applicationForm"
                onChange={this.handleFormChange.bind(this)}
                onSubmit={(e, formState) => piiRetry({
                    form: this.parseForm(formState.getValues()),
                    queryParams: this.props.queryParams
                })}
            >
                <div className="formContainer">
                    <Stack>
                        <Item>
                            <Address />
                        </Item>
                    </Stack>
                    <Stack splitAt="small">
                        <Item breakpoint="small" width="half">
                            <FirstName value={firstName} />
                        </Item>
                        <Item breakpoint="small" width="half">
                            <LastName value={lastName} />
                        </Item>
                    </Stack>
                    <Stack>
                        <Item>
                            <Birthdate>
                                <SocialSecurity />
                            </Birthdate>
                        </Item>
                    </Stack>
                    {
                        this.state.clientResidentState
            && <Stack className="sprk-u-mbl">
                <Item>
                    <Disclosures type={disclosureTypes.accountCreation} clientResidentState={this.state.clientResidentState} location={'PIIRetry'}/>
                </Item>
            </Stack>
                    }
                    <Stack>
                        <Item
                            breakpoint="tiny"
                            width="fourth"
                            className="sprk-o-Box--tiny"
                        >
                            <ContinueButton
                                id="seeMyOptionsButton"
                                text="See My Options"
                                loading={fetchingPIIRetry}
                                showCreditWarning
                            />
                        </Item>
                    </Stack>
                </div>
            </Form>
        );
    }
}

PIIRetryForm.propTypes = {
    piiRetry: PropTypes.func.isRequired,
    fetchingPIIRetry: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    birthdate: PropTypes.string.isRequired,
    streetAddress: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    queryParams: PropTypes.object,
};

const mapStateToProps = (state) => ({
    firstName: UserService.get('firstName'),
    lastName: UserService.get('lastName'),
    birthdate: UserService.get('birthdate'),
    streetAddress: UserService.get('streetAddress'),
    city: UserService.get('city'),
    zip: UserService.get('zip'),
    state: UserService.get('state'),
    code: stateSelectors.getCode(state),
    fetchingPIIRetry: stateSelectors.getFetchingPIIRetry(state),
});

const mapDispatchToProps = (dispatch) => ({
    piiRetry: ({ form, queryParams }) => {
        dispatch(actionCreator.piiRetry({ form, queryParams }));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PIIRetryForm);
